/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventName } from './EventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
    EventNameToJSONTyped,
} from './EventName';

/**
 * 
 * @export
 * @interface SDKEventPersonIdentifiedV1
 */
export interface SDKEventPersonIdentifiedV1 {
    /**
     * 
     * @type {EventName}
     * @memberof SDKEventPersonIdentifiedV1
     */
    event_name: EventName;
    /**
     * Person ID
     * @type {string}
     * @memberof SDKEventPersonIdentifiedV1
     */
    person_id: string;
}



/**
 * Check if a given object implements the SDKEventPersonIdentifiedV1 interface.
 */
export function instanceOfSDKEventPersonIdentifiedV1(value: object): value is SDKEventPersonIdentifiedV1 {
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    if (!('person_id' in value) || value['person_id'] === undefined) return false;
    return true;
}

export function SDKEventPersonIdentifiedV1FromJSON(json: any): SDKEventPersonIdentifiedV1 {
    return SDKEventPersonIdentifiedV1FromJSONTyped(json, false);
}

export function SDKEventPersonIdentifiedV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventPersonIdentifiedV1 {
    if (json == null) {
        return json;
    }
    return {
        
        'event_name': EventNameFromJSON(json['event_name']),
        'person_id': json['person_id'],
    };
}

export function SDKEventPersonIdentifiedV1ToJSON(json: any): SDKEventPersonIdentifiedV1 {
    return SDKEventPersonIdentifiedV1ToJSONTyped(json, false);
}

export function SDKEventPersonIdentifiedV1ToJSONTyped(value?: SDKEventPersonIdentifiedV1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_name': EventNameToJSON(value['event_name']),
        'person_id': value['person_id'],
    };
}

